import { render, staticRenderFns } from "./Page-not-found.vue?vue&type=template&id=2f081c32&"
import script from "./Page-not-found.vue?vue&type=script&lang=js&"
export * from "./Page-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports